import { DefaultFooter } from '@ant-design/pro-components'

function Footer() {
  const currentYear = new Date().getFullYear()
  return <DefaultFooter copyright={`${currentYear} 小菠萝AI导航`} links={[]} />
}

export default Footer
